import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { AgentDetailsResponse } from '../model/agentDetailsResponse.model';
import { UserService } from 'src/app/services/shared/user.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { PersonalDetailsReqRes } from '../../models/personalDetailsReqRes.model';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { UserType } from '../../login/UserType.enum';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'terra-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit {

  agentDetails: AgentDetailsResponse;

  pageForm: UntypedFormGroup;
  isSubmitted = false;
  isGeneralServerError = false;
  generalServerErrorMessage: string = TerraUtils.consts.messages.GENERAL_SUBMIT_ERROR;
  isLoading = false;

  @Input()
  set model(model: AgentDetailsResponse) {
    if (model && !this.agentDetails) {
      this.agentDetails = model;
    }
  }
  get model() {
    return this.agentDetails;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private snackbarService: SnackbarService)
    { }

  ngOnInit() {
    this.generatePageForm();
  }

  generatePageForm() {

    const reqMin2Max30Validators = [Validators.required, Validators.maxLength(30), Validators.minLength(2)];

    this.pageForm = this.fb.group({
      firstName: [null, reqMin2Max30Validators],
      lastName: [null, reqMin2Max30Validators],
      phone1: []
    });

    this.pageForm.patchValue(this.agentDetails);
  }

  save() {
    this.isSubmitted = true;
    this.isGeneralServerError = false;


    if (this.pageForm.valid) {

      this.isLoading = true;

      const model = this.pageForm.value as PersonalDetailsReqRes;
      this.userService.personalDetailsUpdate(model, UserType.Agent)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe(
          response => {
            this.snackbarService.showGeneralMessage('Saved');
          },
          error => {
            this.isGeneralServerError = true;
            this.isLoading = false;
            console.log('Error', error);
          }
        );
    }
  }
}
